import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { BUSINESS, telHref } from '../config/business';
import styles from './Header.module.css';
export function Header() {
  const [open, setOpen] = useState(false);
  const toggle = useRef<HTMLButtonElement>(null);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && open) {
        setOpen(false);
        toggle.current?.focus();
      }
    };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, [open]);
  return (
    <header className={styles.header}>
      <NavLink to="/" className={styles.brand} aria-label="Herculean Homes home">
        <img src="/brand/icon-light.svg" width="52" height="52" alt="" />
        <span>Herculean Homes</span>
      </NavLink>
      <button
        ref={toggle}
        type="button"
        className={styles.menuButton}
        aria-expanded={open}
        aria-controls="primary-nav"
        onClick={() => setOpen(!open)}
      >
        {open ? 'Close −' : 'Menu +'}
      </button>
      <nav
        id="primary-nav"
        aria-label="Primary"
        className={[styles.nav, open ? styles.open : ''].join(' ')}
      >
        <NavLink to="/gallery">Our work</NavLink>
        <NavLink to="/about">Our approach</NavLink>
        {BUSINESS.phone && (
          <a href={telHref(BUSINESS.phone)} aria-label={`Call ${BUSINESS.phone}`}>
            {BUSINESS.phone}
          </a>
        )}
        <NavLink to="/contact" className={styles.contact}>
          Start a conversation <span aria-hidden="true">↗</span>
        </NavLink>
      </nav>
    </header>
  );
}
